// extracted by mini-css-extract-plugin
module.exports = {"paginatorContainer":"Paginator_paginatorContainer__1Muqq","paginatorItem":"Paginator_paginatorItem__vHtyh","isActive":"Paginator_isActive__2JDRc"};